import React from 'react';

interface ManyChatIconProps {
    size?: number;
    color?: string;
    className?: string;
}

const ManyChatIcon: React.FC<ManyChatIconProps> = ({
    size = 20,
    color = 'currentColor',
    className = '',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 80.6 57.6"
            className={className}
            fill={color}
        >
            <path d="M68.2,0h-0.6C51.2,0,43.2,24.6,43.2,24.6V5.7H0v51.9h17.3V23h9.2v34.6H45c0,0,9.5-41,18.4-38c6,2.3-10.9,37.9-10.9,37.9H77c0,0,3.4-23.2,3.4-31.3C81.2,12.6,79,0,68.2,0" />
        </svg>
    );
};

export default ManyChatIcon;
